import { PrefillData } from "./types";
import { SESSION_STORAGE_KEY } from "./constants";

export function parsePrefillData(raw: string | null | undefined): PrefillData | undefined {
  if (!raw) return;
  try {
    return JSON.parse(raw) as PrefillData;
  } catch (err) {
    console.warn(err);
    return;
  }
}

export function clearPrefillStorage(): void {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch (e) {
    console.warn("[basket_param_prefill] clear skipped:", e);
  }
}

export function bindClearPrefillOnParamSubmit(): void {
  document.querySelector('a[href="javascript:document.form_param.submit()"]')?.addEventListener("click", clearPrefillStorage);
}